import React, { useContext, useEffect } from 'react';
import loadable from '@loadable/component';
import { Context } from '../../context/AppContext';

const NotificationBarContent = loadable(() => import('./NotificationBar'));

const NotificationBar = props => {
  const {
    notificationBar: { setNotificationBar, params },
  } = useContext(Context);
  const { show, message, buttons, duration } = props.params || params || {};

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        setNotificationBar({ show: false });
      }, duration);
    }
  }, [show]);

  return show ? (
    <NotificationBarContent
      setNotificationBar={setNotificationBar}
      message={message}
      buttons={buttons}
    />
  ) : (
    ''
  );
};

export default NotificationBar;
